import api from "../index";

export const GetAllAccountApi = (params) => api.get(`IBMaster/MyTeamLive-AccountById?${params}`);
export const MT5RequestAcceptRejectApi = (data) => api.post('Admin/MT5LiveAcc-RejectedApproved', data);
export const GetAllMT5ByIdApi = (MT5Id) => api.get(`MTFiveAccount/UserGetSingle-LiveAccount/${MT5Id}`);
export const CloseMT5TradeApi = (data) => api.post('MTFiveAccount/Close-MT5-Trade', data);  